import React, { useEffect, useMemo, useState, useCallback } from "react";
import DmsService from "Services/DMS/dms-api.service";
import { makeStyles } from "@material-ui/core/styles";
import AlertToastr from "utils/alert";
import Fade from "@material-ui/core/Fade";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import Button from "@material-ui/core/Button";
import useTranslation from "Hooks/useTranslation";
import { connect } from "react-redux";
import { useAuth } from '../../../Contexts/AuthProvider'
import SendMessageToSnsModal from "Components/modals/SendMessageToSnsModal/send-message-to-sns-modal.component";

const descConst = "descending";
const ascConst = "ascending";
const arrowDownClassName = "hasArrow";
const arrowUpClassName = "hasArrow up";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const DevicesPage = () => {
  const translation = useTranslation();
  const classes = useStyles();
  const [sendMessageToSnsModalIsOpen, onSendMessageToSnsModalIsOpenChange] =
    useState(false);
  const [integrationData, setIntegrationData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [devicesMessages, setDevicesMessages] = useState([]);
  

  const { currentUser, currentCompany } = useAuth()

  const allowDevices = useMemo(() => currentUser.allowUiDevices(), [currentUser])

  // const companyId = currentCompany ? currentCompany.id : currentUser?.companyId

  const handleMenuSelect = (itemType) => {
    createUser();
  };

  const fetchDevicesMessages = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await DmsService.getDevicesMessages();
      setDevicesMessages(response.data);
    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.message) {
        AlertToastr.showErrorAlert(error.response.data.message);    
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDevicesMessages();
  }, [fetchDevicesMessages]);
  
  




  const sortedUsers = useMemo(() => {
    let sortableUsers = [...devicesMessages];
    if (sortConfig !== null) {
      if (sortConfig.key === "status") {
        sortableUsers.sort((a, b) => {
          if (a.isActivated < b.isActivated) {
            return sortConfig.direction === ascConst ? -1 : 1;
          }
          if (a.isActivated > b.isActivated) {
            return sortConfig.direction === ascConst ? 1 : -1;
          }
          if (a.isActivated && b.isActivated) {
            if (a.isEnabled < b.isEnabled) {
              return sortConfig.direction === ascConst ? -1 : 1;
            }
            if (a.isEnabled > b.isEnabled) {
              return sortConfig.direction === ascConst ? 1 : -1;
            }
          }
          return 0;
        });
      }
      if (sortConfig.key === "admin") {
        sortableUsers.sort((a, b) => {
          if (a.isAdmin < b.isAdmin) {
            return sortConfig.direction === ascConst ? -1 : 1;
          }
          if (a.isAdmin > b.isAdmin) {
            return sortConfig.direction === ascConst ? 1 : -1;
          }
          if (a.isAdmin && b.isAdmin) {
            if (a.created < b.created) {
              return sortConfig.direction === ascConst ? -1 : 1;
            }
            if (a.created > b.created) {
              return sortConfig.direction === ascConst ? 1 : -1;
            }
          }
          return 0;
        });
      }
      sortableUsers.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === ascConst ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === ascConst ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableUsers;
  }, [devicesMessages, sortConfig]);

  const requestSort = (key) => {
    let direction = ascConst;
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === ascConst
    ) {
      direction = descConst;
    }
    setSortConfig({ key, direction });
  };

  const getClassNamesFor = (name) => {
    if (!sortConfig || sortConfig.key !== name) {
      return;
    }
    if (sortConfig.direction)
      return sortConfig.direction === ascConst
        ? arrowDownClassName
        : arrowUpClassName;
  };





  const editIntegration = (integrationInfo) => {
    setIntegrationData(integrationInfo);
    onSendMessageToSnsModalIsOpenChange(true);
  };

  const createUser = (e) => {
    setIntegrationData(null);
    onSendMessageToSnsModalIsOpenChange(true);    
  };

  const convertToLocalTime = (utcTime) => {
    if (!utcTime) return '';

    const timezone = moment.tz.guess();
    const utcMoment = moment.utc(utcTime);
    
    return utcMoment.tz(timezone).format("DD.MM.YYYY, HH:mm");
  };

  const ensureUrlProtocol = (url) => {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    return `https://${url}`;
  };
 
  if (!allowDevices) {
    return (
      <main>
        <div className="pageBlock">
          <div className="pageCard">
            <div style={{ 
              textAlign: 'center', 
              padding: '40px 20px',
              fontSize: '16px',
              color: '#4444448f'
            }}>
              <div>
                {'You do not have permission to view this page'}
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main>
      <div className="">
        <div className="pageBlock">
          <>
            <div className="pageBtnSection pt0">
              <div className="part">
                <Button
                  className="addItem"
                  variant="contained"
                  color="primary"
                  onClick={handleMenuSelect}
                  disabled={!allowDevices}
                  id="settingsNewDeviceMessageBtn"
                >
                  {translation.sendMessageToSnsModalCreateMessageLabel}
                </Button>
              </div>
            </div>
            <div className="pageCard noPadding">
              <div className="tableHolder">
                <table>
                  <thead>
                    <tr className="headingRow">
                      {/* <th
                        onClick={() => requestSort("type")}
                        className={getClassNamesFor("type")}
                        style={{width: '10%'}}
                      >
                        Id
                      </th> */}
                      <th
                        onClick={() => requestSort("root")}
                        className={`text-center ${getClassNamesFor("root")}`}
                        style={{width: '15%'}}
                      >
                        License Id
                      </th>
                      {/* <th
                        onClick={() => requestSort("activeSessions")}
                        className={`text-center ${getClassNamesFor(
                          "activeSessions"
                        )}`}
                        style={{width: '50%', minWidth: '300px'}}
                      >
                        Certificate
                      </th> */}
                      <th
                        onClick={() => requestSort("sshPort")}
                        className={`text-center ${getClassNamesFor(
                          "sshPort"
                        )}`}
                        style={{width: '20%'}}
                      >
                        sshUrl
                      </th>
                      <th
                        onClick={() => requestSort("webServer1Url")}
                        className={`text-center ${getClassNamesFor(
                          "webServer1Url"
                        )}`}
                        style={{width: '15%'}}
                      >
                        Web Server 1 Url
                      </th>
                      <th
                        onClick={() => requestSort("webServer2Url")}
                        className={`text-center ${getClassNamesFor(
                          "webServer2Url"
                        )}`}
                        style={{width: '15%'}}
                      >
                        Web Server 2 Url
                      </th>
                      <th
                        onClick={() => requestSort("created")}
                        className={getClassNamesFor("created")}
                        style={{width: '15%', textAlign: 'center'}}
                      >
                        Timestamp
                      </th>
                      <th
                        onClick={() => requestSort("created")}
                        className={getClassNamesFor("created")}
                        style={{width: '5%', textAlign: 'center'}}
                      >
                        Is processed
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="5" style={{textAlign: 'center'}}>
                          <CircularProgress />
                        </td>
                      </tr>
                    ) : devicesMessages && devicesMessages.length > 0 ? (
                      sortedUsers.map((message) => {
                        return (
                          <tr
                            key={message.id}
                            style={{pointerEvents: !allowDevices ? 'none' : '', opacity: !allowDevices ? 0.5 : 1}}
                          >
                            {/* <td >
                              <div className="integrationInfo">
                                <span className="userName">
                                  {message.id}
                                </span>
                              </div>
                            </td> */}
                            <td  style={{textAlign: 'center'}}>
                              <span>
                                {message.licenseId}
                              </span>
                            </td>
                            {/* <td  style={{textAlign: 'center', wordBreak: 'break-all', whiteSpace: 'pre-wrap'}}>
                              <span 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(message.certificate);
                                  AlertToastr.showAlert('Certificate copied to clipboard');
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                {message.certificate.length > 100 
                                  ? `${message.certificate.substring(0, 100)}...` 
                                  : message.certificate}
                              </span>
                            </td> */}
                            <td  style={{textAlign: 'center'}}>
                              <span 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(message.sshUrl);
                                  AlertToastr.showAlert('Ssh Url copied to clipboard');
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                              {message.sshUrl}
                              </span>
                            </td>
                            <td style={{textAlign: 'center'}}>
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const url = ensureUrlProtocol(message.webServer1HttpUrl);
                                  if (url) {
                                    window.open(url, '_blank');
                                  }
                                }}
                                disabled={!message.webServer1HttpUrl}
                              >
                                Open
                              </Button>
                            </td>
                            <td style={{textAlign: 'center'}}>
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const url = ensureUrlProtocol(message.webServer2HttpUrl);
                                  if (url) {
                                    window.open(url, '_blank');
                                  }
                                }}
                                disabled={!message.webServer2HttpUrl}
                              >
                                Open
                              </Button>
                            </td>
                            <td  style={{textAlign: 'center'}}>
                              {convertToLocalTime(message.timestamp)}   
                            </td>
                            <td  style={{textAlign: 'center'}}>
                              {message.isProcessed ? 'Yes' : 'No'}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" style={{textAlign: 'center'}}>
                          No messages found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {/* <div className={classes.root}>
                  <Fade in={isLoading} unmountOnExit>
                    <CircularProgress />
                  </Fade>
                </div> */}
              </div>
            </div>
          </>
        </div>
        <SendMessageToSnsModal
          isOpen={sendMessageToSnsModalIsOpen}
          isOpenChangeHandler={onSendMessageToSnsModalIsOpenChange}
          integrationData={integrationData}
          fetchDevicesMessages={fetchDevicesMessages}
        />
        
      </div>
    </main>
  );
};

const mapStateToProps = ({ dashboard }) => ({
  // currentCompany: dashboard.currentCompany,
});

export default connect(mapStateToProps)(DevicesPage);
